module.exports = __webpack_public_path__ + "img/INFOGRAPHIC_Are we on track on the 1.5 degree climate path.5b0e9b57.png";